<i class="material-icons upload-container__icon"
   [ngClass]="{'icon-active' : imageHistoryAvailable,'icon-inactive': !imageHistoryAvailable}"
   [class.disabled-icon]="!imageHistoryAvailable"
   [style.pointer-events]="imageHistoryAvailable ? 'auto' : 'none'"
   (click)="imageHistoryAvailable && openPhoto()">
  photo_library
</i>
